export const VITE_APPLICATION_NAME: string = import.meta.env.VITE_APPLICATION_NAME as string;

export const BASE_URL: string = import.meta.env.VITE_BASE_URL as string;
export const API_URL: string = import.meta.env.VITE_API_BASE_URL as string;
export const LOAN_API_URL: string = import.meta.env.VITE_API_LOAN_URL as string;
export const PAYMENT_LINK_URL: string = import.meta.env.VITE_API_PAYMENT_LINK_URL as string;

export const REPORT_PAGE_SIZE:number = parseInt(import.meta.env.VITE_REPORT_PAGE_SIZE || '10',
  10
);
export const MAX_REPORT_PAGE_SIZE:number = parseInt(import.meta.env.VITE_MAX_REPORT_PAGE_SIZE || '10',
10
);
export const DATE_FILTER_TIME_INTERVAL:number = parseInt(import.meta.env.VITE_DATE_FILTER_TIME_INTERVAL || '10', 10);


export const PHONE_SUPPORT: string = import.meta.env.VITE_WL_COMPANY_PHONE_SUPPORT as string;
export const EMAIL_SUPPORT: string = import.meta.env.VITE_WL_COMPANY_EMAIL_SUPPORT as string;
export const LOGIN_API_URL: string = import.meta.env.VITE_API_LOGIN_URL as string;
export const API_LOGOUT_URL: string = import.meta.env.VITE_API_LOGOUT_URL as string;

export const GA_TOKEN: string = import.meta.env.VITE_GA_TOKEN as string;

export const LOGO_LABEL: boolean = (import.meta.env.VITE_LOGO_LABEL as string) === 'true';

export const LANGUAGE: string = (import.meta.env.VITE_LANGUAGE as string) || 'pt-BR';

// Whitelabel stuff
export const WL_COMPANY_PRIMARY_COLOR: string = import.meta.env.VITE_WL_COMPANY_PRIMARY_COLOR as string;
export const WL_COMPANY_LOGIN_LOGO: string = import.meta.env.VITE_WL_COMPANY_LOGIN_LOGO as string;
export const INVESTMENT_PRODUCTS_COLORS_PIE: string[] = (
  import.meta.env.VITE_WL_COMPANY_INVESTMENT_PRODUCTS_COLORS_PIE as string
).split(',');
export const INVESTMENT_INDEXERS_COLORS_PIE: string[] = (
  import.meta.env.VITE_WL_COMPANY_INVESTMENT_INDEXERS_COLORS_PIE as string
).split(',');

export const KEYCLOAK_LOGIN_ENABLED: boolean = (import.meta.env.VITE_KEYCLOAK_LOGIN_ENABLED as string) === 'true';
export const KEYCLOAK_SERVER_URL: string = import.meta.env.VITE_KEYCLOAK_SERVER_URL as string;
export const KEYCLOAK_AUTH_REALM: string = import.meta.env.VITE_KEYCLOAK_AUTH_REALM as string;
export const KEYCLOAK_CLIENT_ID: string = import.meta.env.VITE_KEYCLOAK_CLIENT_ID as string;

export const WL_BANK_CODE: string | null = import.meta.env.VITE_WL_BANK_CODE ?? null;

export const SENTRY_ENVIRONMENT: string | undefined = import.meta.env.VITE_SENTRY_ENVIRONMENT as
  | string
  | undefined;

// Max length inputs
export const ONBOARDING_MAXLENGTH_LEGALNAME: number = parseInt(import.meta.env.VITE_ONBOARDING_MAXLENGTH_LEGALNAME || undefined) ;
export const ONBOARDING_MAXLENGTH_EMAIL: number = parseInt(import.meta.env.VITE_ONBOARDING_MAXLENGTH_EMAIL || undefined) ;
export const ONBOARDING_MAXLENGTH_CNAE: number = parseInt(import.meta.env.VITE_ONBOARDING_MAXLENGTH_CNAE || undefined) ;
export const ADDRESS_MAXLENGTH_PUBLIC_PLACE: number = 100;
export const ADDRESS_MAXLENGTH_COMPLEMENT: number = 40;
export const ADDRESS_MAXLENGTH_NUMBER: number = 5;
export const ADDRESS_MAXLENGTH_NEIGHBORHOOD: number = 40;
export const ADDRESS_MAXLENGTH_CITY: number = 100 ;
export const ADDRESS_MAXLENGTH_STATE: number = parseInt(import.meta.env.VITE_ADDRESS_MAXLENGTH_STATE || undefined) ;
export const TED_MAXLENGTH_NAME: number = parseInt(import.meta.env.VITE_TED_MAXLENGTH_NAME || undefined) ;

// Firebase
export const FIREBASE_APIKEY: string = import.meta.env.VITE_FIREBASE_APIKEY as string;
export const FIREBASE_AUTHDOMAIN: string = import.meta.env.VITE_FIREBASE_AUTHDOMAIN as string;
export const FIREBASE_PROJECTID: string = import.meta.env.VITE_FIREBASE_PROJECTID as string;
export const FIREBASE_STORAGEBUCKET: string = import.meta.env.VITE_FIREBASE_STORAGEBUCKET as string;
export const FIREBASE_MESSAGINGSENDERID: string = import.meta.env.VITE_FIREBASE_MESSAGINGSENDERID as string;
export const FIREBASE_APPID: string = import.meta.env.VITE_FIREBASE_APPID as string;
export const FIREBASE_MEASUREMENTID: string = import.meta.env.VITE_FIREBASE_MEASUREMENTID as string;
export const FIREBASE_RECAPTCH_APIKEY: string = import.meta.env.VITE_FIREBASE_RECAPTCH_APIKEY as string;

// Security sdk flags
export const USE_SYMMETRIC_ENCRYPTION: boolean = (import.meta.env.VITE_USE_SYMMETRIC_ENCRYPTION as string) === 'true';

// session storage only (logout on close)
export const FORCE_SESSION_STORAGE: boolean = (import.meta.env.VITE_FORCE_SESSION_STORAGE as string) === 'true';

// Idwall SDK
export const IDWALL_SDK_TOKEN: string = import.meta.env.VITE_IDWALL_SDK_TOKEN as string;
export const IDWALL_SDK_URL: string = import.meta.env.VITE_IDWALL_SDK_URL as string;

// Store Links
export const PLAY_STORE_LINK: string = import.meta.env.PLAY_STORE_LINK as string;
export const APP_STORE_LINK: string = import.meta.env.APP_STORE_LINK as string;
